export default {
    buttons: {
        back: "Atrás",
        next: "Próximo",
        submit: "Entregar"
    }
}